import { render, staticRenderFns } from "./FeePlanSection.vue?vue&type=template&id=0f0a9139&scoped=true&"
import script from "./FeePlanSection.vue?vue&type=script&lang=js&"
export * from "./FeePlanSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0a9139",
  null
  
)

export default component.exports